import React from 'react';
import { array, bool, number, object } from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from '@fiverr-private/fiverr_context';
import { Button } from '@fiverr-private/fit';
import { getPackageById, isRecurringGig } from '../../../reducers/packages';
import { selectPackage } from '../../../actions/packages';
import ServiceFeeIcon from '../ServiceFeeIcon';

import './style.scss';

const SelectButton = ({ id, currentPrice, showServiceFeeIcon, onClick }, { currencyConverter, general }) => {
    const formattedPrice = currencyConverter.convertWithFee(currentPrice);
    const btnColor = general.isPro ? Button.COLORS.BLACK : Button.COLORS.GREEN;

    return (
        <>
            <div className="price-wrapper">
                <p className="tbody-5">{formattedPrice}</p>
                { showServiceFeeIcon && <ServiceFeeIcon packageId={id}/> }
            </div>
            <Button type="submit" className="btn-select-package" color={btnColor} onClick={onClick}>
                <I18n k={'gig_page_perseus.packages_table.select'}/>
            </Button>
        </>
    );
};

SelectButton.propTypes = {
    currentPrice: number,
    showServiceFeeIcon: bool
};

SelectButton.contextTypes = {
    currencyConverter: object,
    general: object
};

SelectButton.defaultProps = {
    onClick: () => true
};

const mapStateToProps = ({ packages }, ownProps) => {
    const packageData = getPackageById(packages, ownProps.id);

    return {
        currentPrice: packageData.currentPrice
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onClick: () => {
        dispatch(selectPackage({ packageId: ownProps.id }));
    }
});

const SelectButtonConnect = connect(mapStateToProps, mapDispatchToProps)(SelectButton);

const SelectPackage = ({ packageList, isRecurringGig = false, showServiceFeeIcon = false }) => {
    const showTotalTitle = !isRecurringGig;

    return (
        <tr className="select-package">
            <th>
                {showTotalTitle && <I18n k={'gig_page_perseus.packages_table.total'}/>}
            </th>
            {packageList.map(({ id }) => (
                <td key={id}>
                    <SelectButtonConnect id={id} showServiceFeeIcon={showServiceFeeIcon}/>
                </td>
            ))}
        </tr>
    );
};

SelectPackage.propTypes = {
    packageList: array,
    isRecurringGig: bool,
    showServiceFeeIcon: bool
};

const mapSelectPackageStateToProps = ({ packages }) => {
    const { packageList } = packages;

    return {
        packageList,
        isRecurringGig: isRecurringGig(packages)
    };
};

export { SelectPackage, SelectButton };
export default connect(mapSelectPackageStateToProps)(SelectPackage);
